module.exports = __webpack_public_path__ + "img/outline-qdap-black.7e0c106.svg";